import Reveal from "./Reveal";

const steps = [
  {
    n: "01",
    title: "Beskriv ditt behov",
    text: "Berätta vad du vill ha hjälp med. Det räcker med några rader om tak, fasad eller utsatta ytor.",
    testid: "process-step-1",
  },
  {
    n: "02",
    title: "Vi går igenom förutsättningarna",
    text: "Vi tittar närmare på situationen och återkommer med en tydlig bild av vad som behöver göras.",
    testid: "process-step-2",
  },
  {
    n: "03",
    title: "Du får hjälp med rätt åtgärd",
    text: "Vi utför arbetet med skonsamma metoder, kontrollerar resultatet och städar efter oss.",
    testid: "process-step-3",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="section-process"
      className="bg-[#1A362B] text-[#F7F5F0] py-24 md:py-32 relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.05] bg-grain pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-16 md:mb-24">
          <Reveal className="lg:col-span-7">
            <div className="text-[11px] tracking-[0.22em] uppercase text-[#F7F5F0]/65">
              Arbetsprocess
            </div>
            <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-balance">
              Så fungerar <span className="text-[#C4A67B]">det</span>
            </h2>
          </Reveal>
          <Reveal className="lg:col-span-5">
            <p className="text-[#F7F5F0]/75 leading-relaxed">
              Tre enkla steg från första kontakt till färdigt arbete — utan
              krångel och utan dolda tillägg.
            </p>
          </Reveal>
        </div>

        <ol className="grid md:grid-cols-3 gap-px bg-[#F7F5F0]/10 rounded-2xl overflow-hidden border border-[#F7F5F0]/10">
          {steps.map((s, i) => (
            <Reveal
              key={s.n}
              as="li"
              delay={i * 100}
              data-testid={s.testid}
              className="bg-[#1A362B] p-8 md:p-10 relative"
            >
              <div className="font-serif-display text-7xl md:text-8xl text-[#F7F5F0]/10 leading-none">
                {s.n}
              </div>
              <h3 className="mt-6 font-serif-display text-xl md:text-2xl leading-tight">
                {s.title}
              </h3>
              <p className="mt-3 text-[#F7F5F0]/70 text-[15px] leading-relaxed">
                {s.text}
              </p>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}
